//
//
//
//
//
//
//
//
//
//

import seguroEmpateMixin from '~/mixins/seguro-empate'

export default {
  name: 'ElementsSeguroEmpateMark',
  mixins: [seguroEmpateMixin],
  props: {
    selection: {
      default: null
    },
    freebet: {
      default: null
    },
    variant: {
      type: String,
      default: 'chip'
    }
  },
  computed: {
    active() {
      return this.seguroEmpateActive(this.selection, this.freebet)
    }
  }
}
